import { Category } from './../category.type';

export class CategoryHelper {
  static transform(data: Category[], key = ''): Category[] {
    if (!Array.isArray(data)) data = [data];
    return data.map((node) => {
      const { childrenContent, ...rest } = node;
      return {
        ...rest,
        selectable: true,
        children: childrenContent ? this.transform(childrenContent, key) : [],
        key: node.categoryId + (key || ''),
      };
    });
  }

  static filterCategoryByLocale(node: Category, locale: string, show = false): Category | null {
    const label = node.categoryLabel == null ? null : node.categoryLabel.find((l) => l.locale === locale);
    if (!label) return null;

    const tree = node.categoryBreadcrumb == null ? null : node.categoryBreadcrumb.find((l) => l.locale === locale);
    if (!tree) return null;
    const filteredNode: Category = {
      ...node,
      selectable: true,
      categoryBreadcrumbLoc: tree.label,
    };
    if (show) {
      filteredNode['categoryLabelLoc'] = label.label + ` (${locale})`;
      filteredNode['label'] = label.label + ` (${locale})`;
    } else {
      filteredNode['categoryLabelLoc'] = label.label;
      filteredNode['label'] = label.label;
    }

    if (node.children) {
      filteredNode.children = this.handleChildren(node, locale, show);
    }
    return filteredNode;
  }

  static getCategoryById(nodes, id) {
    const categs = this.flattenTree(nodes);
    return categs.filter((node) => node.categoryId == id)?.[0]?.categoryLabelLoc;
  }

  static flattenTree(nodes: Category[]): Category[] {
    return nodes.reduce((acc, node) => {
      if (node.children.length === 0) {
        return [...acc, node];
      }
      return [...acc, node, ...this.flattenTree(node.children)];
    }, []);
  }

  static handleChildren(node, locale, show = false) {
    return node.children
      .map((child) => this.filterCategoryByLocale(child, locale, show))
      .filter((child) => child !== null) as Category[];
  }

  static filterTreeByLocale(nodes: Category[], locale: string): Category[] {
    return nodes
      .filter((node) => node !== null)
      .map((node) => this.filterCategoryByLocale(node, locale))
      .filter((node) => node !== null);
  }

  static filterTreeByLocales(nodes: Category[], locales): Category[] {
    let nodesReturn = [];
    let show = false;
    if (locales.length > 1) {
      show = true;
    }
    for (let locale of locales) {
      nodesReturn = nodesReturn.concat(
        nodes.filter((node) => node !== null).map((node) => this.filterCategoryByLocale(node, locale, show)),
      );
    }
    return nodesReturn;
  }
}
